import { REPORT_GROUP_TYPE } from 'lib/const/ReportData';
import React from 'react';
import { useTheme } from 'styled-components/macro';
import { ParagraphExtraSmallBold } from '../styles/typography';
import { SingleAvailableField } from './SingleAvailableField';
import { AvailableGroupListProps } from './types';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useCDK } from 'lib/hooks/useCdk';

const getFieldTitle = (name: string, t: TFunction, isCdkUser: boolean) => {
  switch (name) {
    case REPORT_GROUP_TYPE.POPULAR:
      return t('Most Popular');
    case REPORT_GROUP_TYPE.COVIDEO:
      return isCdkUser
        ? t('Sending from crm video')
        : t('Sending from Covideo');
    case REPORT_GROUP_TYPE.SERVICE:
      return t('Service Related');
  }
};

export const AvailableGroupFieldsList = ({
  allFields,
  isMaxFieldReached,
  selectedFields,
  onAddClickHandler,
}: AvailableGroupListProps) => {
  const { colors } = useTheme();
  const { t } = useTranslation();
  const { isCdkUser } = useCDK();
  return (
    <>
      {Object.keys(allFields).map((groupField, idx) => (
        <React.Fragment key={idx}>
          <ParagraphExtraSmallBold
            color={colors.neutral[60]}
            m={idx === 0 ? '0px 0 8px 0' : '16px 0 8px 0'}
            style={{ textTransform: 'uppercase' }}
          >
            {getFieldTitle(groupField, t, isCdkUser)}
          </ParagraphExtraSmallBold>
          {allFields[groupField as REPORT_GROUP_TYPE].map(field => {
            const isSelected = selectedFields.some(
              item => item.value === field.value
            );

            const isSelectionOrMaxReached = isSelected || isMaxFieldReached;
            return (
              <SingleAvailableField
                key={field.value}
                onAddClickHandler={onAddClickHandler}
                isSelectionOrMaxReached={isSelectionOrMaxReached}
                isSelected={isSelected}
                field={field}
              />
            );
          })}
        </React.Fragment>
      ))}
    </>
  );
};
